import React from 'react';
import IconBase from './IconBase';

const ShareIcon = props => {
    return (
        <IconBase viewBox={'0 0 40 40'} {...props}>
            <path d="M30.2,36.7c-1.3,0-2.5-0.5-3.4-1.4c-0.9-0.9-1.4-2.1-1.4-3.4c0-0.2,0-0.4,0.1-0.7c0-0.2,0.1-0.5,0.2-0.7l-12.3-7.2c-0.4,0.5-1,0.8-1.6,1.1c-0.6,0.3-1.2,0.4-1.9,0.4c-1.3,0-2.5-0.5-3.4-1.4C5.5,22.5,5,21.3,5,20s0.5-2.5,1.4-3.4c0.9-0.9,2.1-1.4,3.4-1.4c0.6,0,1.2,0.1,1.8,0.4c0.6,0.2,1.1,0.6,1.6,1l12.3-7.1c-0.1-0.2-0.1-0.4-0.2-0.6c0-0.2-0.1-0.5-0.1-0.7c0-1.3,0.5-2.5,1.4-3.4c0.9-0.9,2.1-1.4,3.4-1.4c1.3,0,2.5,0.5,3.4,1.4C34.6,5.7,35,6.8,35,8.2s-0.5,2.5-1.4,3.4c-0.9,0.9-2.1,1.4-3.4,1.4c-0.6,0-1.3-0.1-1.9-0.3c-0.6-0.2-1.1-0.6-1.5-1l-12.3,6.9c0.1,0.2,0.1,0.4,0.1,0.7c0,0.3,0.1,0.5,0.1,0.7s0,0.4-0.1,0.6c0,0.2-0.1,0.4-0.1,0.6l12.3,7.1c0.4-0.4,0.9-0.7,1.5-1c0.6-0.2,1.2-0.4,1.9-0.4c1.3,0,2.5,0.5,3.4,1.4c0.9,0.9,1.4,2.1,1.4,3.4c0,1.3-0.5,2.5-1.4,3.4C32.7,36.2,31.5,36.7,30.2,36.7z"/>
        </IconBase>
    )
}

export default ShareIcon;